export default "__VITE_ASSET__vzEwy_b___"